var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNamibia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.981 437.02C85.72 447.759 97.178 457.336 109.197 465.768L465.766 109.198C457.335 97.1789 447.758 85.7209 437.018 74.9819C426.279 64.2429 414.821 54.6669 402.802 46.2349L46.234 402.805C54.665 414.822 64.242 426.281 74.981 437.02V437.02Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.981 74.9801C-5.78297 155.744 -21.287 277.036 28.436 373.378L373.378 28.4371C277.036 -21.2859 155.743 -5.77988 74.981 74.9801V74.9801Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.019 437.02C517.781 356.258 533.285 234.965 483.564 138.622L138.622 483.564C234.963 533.287 356.256 517.783 437.019 437.02Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.478 144.696L182.792 158.189L198.068 185.971L166.919 180.013L162.971 211.478L141.275 188.335L119.578 211.478L115.632 180.013L84.482 185.97L99.757 158.188L71.072 144.696L99.758 131.202L84.482 103.422L115.631 109.38L119.579 77.9131L141.275 101.057L162.972 77.9131L166.919 109.38L198.068 103.422L182.794 131.203L211.478 144.696Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/namibia.c19af49e0727c7d30834cbd818811555.svg";
export { ForwardRef as ReactComponent };